<template lang="pug">
	<svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path fill-rule="evenodd" clip-rule="evenodd" d="M12.0003 6.50016C12.0003 9.53758 9.5379 12 6.50016 12C3.46274 12 1 9.53758 1 6.50016C1 3.46242 3.46274 1 6.50016 1C9.5379 1 12.0003 3.46242 12.0003 6.50016Z" stroke="#AAAAAA"/>
		<path fill-rule="evenodd" clip-rule="evenodd" d="M6.22094 3.72502C6.22094 3.33455 6.52794 3.04674 6.91841 3.04674C7.28074 3.04674 7.58742 3.3256 7.58742 3.68793C7.58742 4.0784 7.27146 4.36653 6.88099 4.36653C6.51866 4.36653 6.22094 4.09695 6.22094 3.72502ZM5.22669 9.42346C5.22669 9.17242 5.29161 8.89356 5.3658 8.60542L5.95135 6.2351C5.98844 6.09567 6.00731 5.97478 6.00731 5.90059C6.00731 5.68665 5.85861 5.69592 5.50523 5.94664L5.30088 6.08639L5.16145 5.90955C5.70063 5.35182 6.28617 4.93353 6.8068 4.93353C7.15058 4.93353 7.27146 5.16602 7.27146 5.46375C7.27146 5.66778 7.2155 6.01188 7.10421 6.45831L6.53689 8.70775C6.50907 8.81936 6.49084 8.92138 6.49084 9.02371C6.49084 9.24693 6.65778 9.24693 6.98333 9.04226L7.24364 8.88428L7.38307 9.06113C6.90882 9.5162 6.34182 9.95336 5.73772 9.95336C5.38467 9.95336 5.22669 9.68377 5.22669 9.42346Z" fill="#7B96B2"/>
	</svg>

</template>

<script>
export default {

}
</script>

<style>

</style>
